import { SceneWrapper, Steps } from '~/components';
import type { IconProp } from '~/modules';
import { ButtonComponent, Title } from './styles';

type Props = {
  steps: {
    icon: IconProp;
    description: string;
  }[];
  handleNext: () => void;
};

const OnboardingIntro = ({ steps, handleNext }: Props) => {
  return (
    <SceneWrapper
      footer={
        <ButtonComponent id="initialize-onboarding" onPress={handleNext}>
          INICIAR CADASTRO
        </ButtonComponent>
      }
    >
      <Title>Vamos começar o processo de autenticação</Title>
      <Steps title="Etapas:" items={steps} />
    </SceneWrapper>
  );
};

export default OnboardingIntro;
